import { render, staticRenderFns } from "./FluteBird.vue?vue&type=template&id=6675c2c9&scoped=true"
import script from "./FluteBird.vue?vue&type=script&lang=js"
export * from "./FluteBird.vue?vue&type=script&lang=js"
import style0 from "./FluteBird.vue?vue&type=style&index=0&id=6675c2c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675c2c9",
  null
  
)

export default component.exports